import ApiService from '../services/apiService';

export const fetchOvertimeCompensationsRequest = ({ dispatch, params = {}, failureCallback, successCallback }) => {
  ApiService.request('get', '/overtime_compensations', {
    dispatch,
    params,
    failureCallback,
    successCallback
  });
};

export const exportOvertimeCompensationRequest = ({ dispatch, params = {}, failureCallback, successCallback }) => {
  ApiService.request('get', `/overtime_compensations/export.xlsx`, {
    dispatch,
    params,
    responseType: 'text',
    failureCallback,
    successCallback
  });
};

export const preImportOvertimeCompensationRequest = ({
  dispatch,
  params,
  formData,
  failureCallback,
  successCallback
}) => {
  ApiService.request('get', '/overtime_compensations/pre_import', {
    dispatch,
    params,
    formData,
    failureCallback,
    successCallback
  });
};

export const importOvertimeCompensationRequest = ({ dispatch, params, formData, failureCallback, successCallback }) => {
  ApiService.request('post', '/overtime_compensations/import', {
    dispatch,
    params,
    formData,
    failureCallback,
    successCallback
  });
};

export const importTemplateOvertimeCompensationRequest = ({ dispatch, params, failureCallback, successCallback }) => {
  ApiService.request('get', '/overtime_compensations/import_template', {
    dispatch,
    params,
    responseType: 'text',
    failureCallback,
    successCallback
  });
};

export const fetchOvertimeCompensationRequests = ({ dispatch, params = {}, failureCallback, successCallback }) => {
  ApiService.request('get', '/overtime_compensation_requests', {
    dispatch,
    params,
    failureCallback,
    successCallback
  });
};

export const createOvertimeCompensationRequest = ({ dispatch, params, formData, failureCallback, successCallback }) => {
  ApiService.request('post', '/overtime_compensation_requests', {
    dispatch,
    params,
    formData,
    failureCallback,
    successCallback
  });
};

export const deleteOvertimeCompensationRequest = (id, { dispatch, successCallback, callback }) => {
  ApiService.request('delete', `/overtime_compensation_requests/${id}`, {
    dispatch,
    successCallback,
    callback
  });
};

export const approveOvertimeCompensationRequest = (
  id,
  { dispatch, params, formData, failureCallback, successCallback, callback }
) =>
  ApiService.request('post', `/overtime_compensation_requests/${id}/approve`, {
    dispatch,
    params,
    formData,
    failureCallback,
    successCallback,
    callback
  });

export const rejectOvertimeCompensationRequest = (id, { dispatch, params, formData, successCallback, callback }) =>
  ApiService.request('post', `/overtime_compensation_requests/${id}/reject`, {
    dispatch,
    params,
    formData,
    successCallback,
    callback
  });
